import React from 'react';

const Ua = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_46_45)">
        <path d="M16 0H0V16H16V0Z" fill="#0057B7" />
        <path d="M16 8H0V16H16V8Z" fill="#FFD700" />
      </g>
      <defs>
        <clipPath id="clip0_46_45">
          <rect width="16" height="16" rx="3" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Ua;
